import React, { useEffect, useState } from 'react';
import FacebookIcon from '../../../components/icons/facebook';
import HauzIcon from '../../../components/icons/hauz';
import MailIcon from '../../../components/icons/mail';
import PinterestIcon from '../../../components/icons/pinterest';
import TwitterIcon from '../../../components/icons/twitter';
import SocialShareModal from './modal';
import FacebookBlogIcon from 'icons/facebook-blog-icon';
import TwitterBlogIcon from 'icons/twitter-blog-icon';
import PinterestBlogIcon from 'icons/pinterest-blog-icon';
import MailBlogIcon from 'icons/mail-blog-icon';
import { gtmShare } from 'helpers/utils/gtm-events/gtmEccomerce';

interface ProductShareProps {
  selectedVariant?: any;
  productName?: string;
  itemId?: string;
  selectedImageUrl?: string;
}

const SocialShare: React.FC<ProductShareProps> = ({ productName, itemId, selectedVariant, selectedImageUrl }) => {
  const isOnBlogPage = !productName;
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const [currentUrl, setCurrentUrl] = useState<string>('');

  const shareURLs = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`,
    twitter: !isOnBlogPage
      ? `https://twitter.com/intent/tweet?url=${encodeURIComponent(
          currentUrl + '?color=' + selectedVariant?.attributes?.actualColor?.split(' ').join('+'),
        )}&text=Check Out ${productName} from Shades of Light`
      : `https://twitter.com/intent/tweet?url=${currentUrl}`,
    pinterest: `https://pinterest.com/pin/create/button/?url=${currentUrl}`,
    houzz: `https://www.houzz.com/imageClipperUpload?imageUrl=${selectedImageUrl}`,
  };

  const shareOptions = [
    {
      order: 1,
      title: 'Share on Facebook (opens in new window)',
      ariaLabel: 'Share on Facebook (opens in new window)',
      onClick: () => onShareClickHandler('facebook', shareURLs.facebook),
      icon: isOnBlogPage ? <FacebookBlogIcon /> : <FacebookIcon className="fill-sol-300" />,
    },
    {
      order: isOnBlogPage ? 3 : 2,
      title: 'Share on Twitter (opens in new window)',
      ariaLabel: 'Share on Twitter (opens in new window)',
      onClick: () => onShareClickHandler('twitter', shareURLs.twitter),
      icon: isOnBlogPage ? <TwitterBlogIcon /> : <TwitterIcon className="fill-sol-300" />,
    },
    {
      order: isOnBlogPage ? 2 : 3,
      title: 'Share on Pinterest (opens in new window)',
      ariaLabel: 'Share on Pinterest (opens in new window)',
      onClick: () => onShareClickHandler('pinterest', shareURLs.pinterest),
      icon: isOnBlogPage ? <PinterestBlogIcon /> : <PinterestIcon className="fill-sol-300" />,
    },
    ...(!isOnBlogPage
      ? [
          {
            order: 4,
            title: 'Share on Houzz (opens in new window)',
            ariaLabel: 'Share on Houzz (opens in new window)',
            onClick: () => onShareClickHandler('houzz', shareURLs.houzz),
            icon: <HauzIcon className="fill-sol-300" />,
          },
        ]
      : []),
    {
      order: 5,
      title: 'Share by Email',
      ariaLabel: 'Share by Email',
      onClick: () => setIsShareModalOpen(true),
      icon: isOnBlogPage ? <MailBlogIcon /> : <MailIcon className="fill-sol-300 mt-1 h-6 w-6" />,
    },
  ];

  const trackShare = (social: string) => {
    let content_type = 'unknown';

    if (isOnBlogPage) content_type = 'blog';
    if (productName) content_type = 'product';

    let item_id = window.location.pathname;

    if (isOnBlogPage) item_id = window.location.pathname.replace('/blogs/', '');
    if (productName && itemId) item_id = itemId;

    const gtmTrack = {
      method: social,
      content_type,
      item_id,
    };

    gtmShare(gtmTrack);
  };

  const onShareClickHandler = (social: string, shareUrlLink: string) => {
    trackShare(social);
    window.open(shareUrlLink, '_blank', 'width=1000,height=475');
  };

  useEffect(() => {
    setCurrentUrl(window.location.origin + window.location.pathname);
  }, []);
  return (
    <section className={`flex px-2 ${isOnBlogPage ? '' : 'lg:justify-end'}`}>
      <section className="flex items-center gap-5">
        <p className="text-xs font-semibold leading-[15px] text-[#222222]">Share:</p>
        <ul className="flex items-end gap-5">
          {shareOptions
            .sort((a, b) => a.order - b.order)
            .map((option, index) => (
              <li key={index}>
                <button
                  className="hover:opacity-60"
                  title={option.title}
                  aria-label={option.ariaLabel}
                  onClick={option.onClick}
                >
                  {option.icon}
                </button>
              </li>
            ))}
        </ul>
      </section>

      <SocialShareModal
        onShare={() => trackShare('email')}
        modelOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        url={currentUrl}
      />
    </section>
  );
};

export default SocialShare;
